import { Field, Form, Formik } from "formik"
import React, { useState } from "react"
import { toastCreate, toastUpdate } from "../../utils/notifications/toast"
import SideContainerAnimated from "../SideContainer"
import SideForm from "../SideForm"
import { IFormEditProduct } from "./interface"
import { Legend, Row } from "./style"
import pencil from "../../assets/icons/pencil.svg";
import * as Yup from "yup"
import Input from "../Input"
import Select from "../Select"
import { useSelector } from "react-redux"
import Button from "../Button"
import { useQuery } from "react-query"
import { editProduct } from "../../hooks/editProduct"
import { getGroups } from "../../hooks/getGroups"
import { IGroupProduct } from "../../views/ecommerce/group/interfaces"
import { TIME_INFO } from "../../utils/notifications/time"

const FormEditProduct = ({
    isVisible,
    formState,
    selectedProduct,
    setRefresh
}: IFormEditProduct
): React.ReactElement => {

    const login = useSelector((state: {login: any}) => state.login);
    const [groups, setGroups] = useState<Array<IGroupProduct>>([])
    
    useQuery("getGroupEditProduct", () => getGroups(login, setGroups))

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(),
        description: Yup.string().required(),
        amount: Yup.string().required(),
        group: Yup.string().required(),
    })

    const submitForm = async (values: any, resetForm: Function) => {
        const { isError  } = await editProduct(values, selectedProduct)
        
        if(!isError) {
            formState("close")
            resetForm()
            setRefresh(true)
        }
    }

    return (
        <SideContainerAnimated isVisible={isVisible}>
            <SideForm
                title="Editar produto"
                icon={pencil}
                sizeIcon={20}
                visible={() => formState("close")}
            >   
                <Formik
                    initialValues={{
                        name: "",
                        amount: "",
                        description: "",
                        group: ""
                    }}
                    validationSchema={validationSchema}
                    onSubmit={async (values, {resetForm}) => {
                        await submitForm(values, resetForm)
                    }}
                >
                    {({initialValues,values, errors, handleChange, dirty, isValid, touched}) => {
                        initialValues.amount = selectedProduct.amount.slice(0,-2) + "," + selectedProduct.amount.slice(-2),
                        initialValues.name = selectedProduct.nameProduct!,
                        initialValues.description = selectedProduct.description!,
                        initialValues.group = groups.filter(item => item.id === selectedProduct.groupId)[0]?.description
                        
                        return (
                            <Form>
                                <Row>
                                    <Legend>Edite seu produto</Legend>
                                    <Field 
                                        id="name" 
                                        name="name" 
                                        className="inputCustom" 
                                        placeholder="Nome"
                                        maxLength={28}
                                        isError={touched.name && errors.name}
                                        as={Input}
                                    />
                                    <Field 
                                        id="description" 
                                        name="description" 
                                        className="inputCustom" 
                                        placeholder="Descrição do produto" 
                                        isError={touched.description && errors.description}
                                        as={Input}
                                    />
                                    <Field 
                                        id="amount" 
                                        name="amount"
                                        type="text"
                                        className="inputCustom"
                                        value={values.amount}
                                        placeholder="Valor" 
                                        isError={touched.amount && errors.amount}
                                        as={Input}
                                    />
                                    <Field 
                                        name="group"
                                        onChange={handleChange}   
                                        isError={touched.group && errors.group}
                                        value={values.group}
                                        as={Select}
                                    >
                                        { 
                                            groups.map((group: IGroupProduct, index: number) => {
                                                return (
                                                    <option 
                                                        key={index} 
                                                        value={group.id}
                                                    >
                                                        { group.description }
                                                    </option>
                                                )
                                            })
                                        }
                                    </Field>
                                </Row>
                                <Row>
                                    <Button 
                                        onClick={() => {
                                            toastCreate("updateProduct",
                                                "info",
                                                TIME_INFO,
                                                "Processando"
                                            )
                                        }} 
                                        disabled={ !(dirty && isValid)}
                                        type="submit">
                                            Editar produto
                                    </Button>
                                </Row>
                            </Form>
                        )
                    }}
                </Formik>
            </SideForm>
        </SideContainerAnimated>
    )
}

export default FormEditProduct